import React, { FC, useContext } from 'react'
import { BannerVariant } from '@getgo/chameleon-core/next'
import { InfoOutlinedIcon } from '@getgo/chameleon-icons/react'
import { Banner } from '@getgo/chameleon-web-react-wrapper'

import { TopBarBannerContext } from 'components'

interface TopBarBannerProps {
  setUpgradeBannerOpen?: (state: boolean) => void
}

const TopBarBanner: FC<TopBarBannerProps> = () => {
  const { topBanner, dismissBanner } = useContext(TopBarBannerContext)

  const getVariant = (variant: string | undefined): BannerVariant => {
    if (!variant) {
      return 'neutral'
    }
    switch (variant) {
      case 'danger':
        return 'danger'
      case 'success':
        return 'success'
      case 'marketing':
        return 'marketing'
      default:
        return 'neutral'
    }
  }

  return (
    <>
      {topBanner && (
        <Banner
          icon={topBanner.icon || <InfoOutlinedIcon />}
          variant={getVariant(topBanner.variant)}
          closable={topBanner.closable}
          action={topBanner.action}
          onClose={dismissBanner}
        >
          {topBanner.message}
        </Banner>
      )}
    </>
  )
}

export default TopBarBanner
